import {
  IonContent,
  IonHeader,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonLoading,
  IonPage,
} from '@ionic/react'
import { useRouteMatch } from 'react-router-dom'

import Header from '../../../components/header'
import { useInfiniteData } from '../../../hooks/use-infinite-data'
import { CheckInListItem } from '../../../check-in/paired/components/check-in-list-item'
import { usePastCheckIns } from '../../../check-in/paired/queries'

function PastCheckInsPage() {
  const stationClients = usePastCheckIns()
  const flatStations = stationClients.data?.pages.flatMap((d) => d.data)
  const { url } = useRouteMatch()

  const [ionInfiniteScrollRef, loadMore] = useInfiniteData(
    stationClients.fetchNextPage
  )

  return (
    <IonPage>
      <IonHeader>
        <Header title="Past Check-Ins" showMenu btn={null} />
      </IonHeader>
      <IonContent className="ion-padding">
        {flatStations ? (
          <div className="space-y-5">
            {flatStations.map((stationClient) => (
              <CheckInListItem
                key={stationClient.objectId}
                href={
                  stationClient.client
                    ? `${url}/loyalty-detail?clientId=${stationClient.client.objectId}`
                    : undefined
                }
                stationClient={stationClient}
              />
            ))}
            <IonInfiniteScroll
              ref={ionInfiniteScrollRef}
              onIonInfinite={loadMore}
              threshold="100px"
              disabled={!stationClients.hasNextPage}
            >
              <IonInfiniteScrollContent
                loadingSpinner="bubbles"
                loadingText="loading..."
              />
            </IonInfiniteScroll>
          </div>
        ) : (
          <IonLoading message="Loading Past Check-Ins" isOpen />
        )}
      </IonContent>
    </IonPage>
  )
}

export { PastCheckInsPage }
